import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66a3b806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "container lazyload" }
const _hoisted_3 = {
  id: "h_top",
  class: "lazyload"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "ララちゃんランドセル",
    class: "lazyload",
    "data-src": "https://raraya.co.jp/wp-content/themes/raraya-evolution/images/common/h2501.png",
    src: "https://raraya.co.jp/wp-content/themes/raraya-evolution/images/common/h2501.png?v=202501160001"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "ララちゃんランドセル")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h_nav lazyload" }, [
  /*#__PURE__*/_createElementVNode("nav", {
    id: "gNav",
    role: "navigation"
  }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "nav" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup" }, "ランドセル一覧"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/order" }, "オーダーメイド")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup/cosmorainbow" }, "コスモレインボー")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/collection" }, "コレクション")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/magicalbelt" }, "別売マジかるベルト")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup/lessonbag" }, "レッスンバッグ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/searchconditions" }, "ランドセルを探す"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/boy" }, "男の子向けのランドセル")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/girl" }, "女の子向けのランドセル")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/design" }, "デザインから探す")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/color" }, "色から探す")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/catalog" }, "カタログ請求")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/inquiry" }, "お問い合わせ"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/faq" }, "よくある質問")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/hookerchart" }, "安全フッカー請求")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/guide/after-service" }, "アフターサービス")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/shipment" }, "商品のお届け予定")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret" }, "ララちゃんの特徴"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/bellbio5" }, "生地について")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/majicalbelt" }, "マジかるベルトについて")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret#feature-link02" }, "背負い心地")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret#feature-link05" }, "安心・安全サポート")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret#feature-link01" }, "たっぷり収納")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret#feature-link03" }, "強さのヒミツ")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret#feature-link04" }, "毎日使いやすい")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/realcheck" }, "展示会・取扱店"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom" }, "直営ショールーム")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom/exhibition" }, "展示会")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom/agency" }, "全国取扱店")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://raraya-rarachan.com/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, "おうちでラン活")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "MENU", -1))
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/lineup\" data-v-66a3b806>ランドセル一覧</a><ul class=\"sub-menu\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/order\" data-v-66a3b806>オーダーメイド</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/lineup/cosmorainbow\" data-v-66a3b806>コスモレインボー</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/collection\" data-v-66a3b806>コレクション</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/magicalbelt\" data-v-66a3b806>別売マジかるベルト</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/lineup/lessonbag\" data-v-66a3b806>レッスンバッグ</a></li></ul></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/searchconditions\" data-v-66a3b806>ランドセルをさがす</a><ul class=\"sub-menu\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/boy\" data-v-66a3b806>男の子向けのランドセル</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/girl\" data-v-66a3b806>女の子向けのランドセル</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/design\" data-v-66a3b806>デザインから探す</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/color\" data-v-66a3b806>色から探す</a></li></ul></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/catalog\" data-v-66a3b806>カタログ請求</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/inquiry\" data-v-66a3b806>お問い合わせ</a><ul class=\"sub-menu\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/faq\" data-v-66a3b806>よくある質問</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/hookerchart\" data-v-66a3b806>安全フッカー請求</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/guide/after-service\" data-v-66a3b806>アフターサービス</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/shipment\" data-v-66a3b806>商品のお届け予定</a></li></ul></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret\" data-v-66a3b806>ララちゃんの特徴</a><ul class=\"sub-menu\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/bellbio5\" data-v-66a3b806>生地について</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/majicalbelt\" data-v-66a3b806>マジかるベルトについて</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret#feature-link01\" data-v-66a3b806>背負い心地</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret#feature-link02\" data-v-66a3b806>安心・安全サポート</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret#feature-link03\" data-v-66a3b806>たっぷり収納</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret#feature-link04\" data-v-66a3b806>強さのヒミツ</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/secret#feature-link05\" data-v-66a3b806>毎日使いやすい</a></li></ul></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/realcheck\" data-v-66a3b806>展示会・取扱店</a><ul class=\"sub-menu\" data-v-66a3b806><li data-v-66a3b806><a href=\"https://raraya.co.jp/showroom\" data-v-66a3b806>直営ショールーム</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/showroom/exhibition\" data-v-66a3b806>展示会</a></li><li data-v-66a3b806><a href=\"https://raraya.co.jp/showroom/agency\" data-v-66a3b806>全国取扱店</a></li><li data-v-66a3b806><a href=\"https://raraya-rarachan.com/\" rel=\"noopener noreferrer\" target=\"_blank\" data-v-66a3b806>おうちでラン活</a></li></ul></li></ul>", 1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_ModeButton = _resolveComponent("ModeButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", {
          class: _normalizeClass(["h_logo", { active: _ctx.menuVisible }])
        }, _hoisted_5, 2),
        _hoisted_6,
        _createVNode(_component_FavoriteButton, { class: "hide-desktop" }),
        _createVNode(_component_ModeButton, {
          isMobile: true,
          class: "header-mode-button"
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["hamburger pc-none", [{ active: _ctx.menuVisible }, { 'is-fixed': _ctx.menuVisible }]]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, _hoisted_11, 2),
        _createElementVNode("nav", {
          class: _normalizeClass(["globalMenuSp pc-none", { active: _ctx.menuVisible }])
        }, _hoisted_13, 2)
      ])
    ])
  ]))
}